(function (window) {
    window.JVZoo = window.JVZoo || {};
    window.JVZoo.Checkout = window.JVZoo.Checkout || {};

    if (window.JVZoo.Checkout.Session) {
        return;
    }

    // Server-side CheckoutSessionConstants is the source of truth; the host
    // processor passes the configured value through init(). This default only
    // applies when the host omits it.
    var DEFAULT_EXPIRY_DAYS = 7;
    var MS_PER_DAY = 24 * 60 * 60 * 1000;
    // setTimeout caps at 2^31 - 1 ms (~24.85 days). Stay safely under it.
    var MAX_EXPIRY_MS = 24 * MS_PER_DAY;
    var SESSION_EXPIRY_MESSAGE = 'This checkout session has expired. Please refresh the page to continue.';
    var LOG_PREFIX = '[session-expiry]';

    var _timer = null;
    var _startedAt = null;
    var _locked = false;
    var _config = {};
    var _enabled = true;
    var _expiryMs = DEFAULT_EXPIRY_DAYS * MS_PER_DAY;

    /**
     * Configure the module before use. Call once during checkout init.
     *
     * @param {object} options
     * @param {function(string):void} options.onLock          Processor-specific UI handler invoked when the
     *                                                        session locks. Receives the lock reason. Should
     *                                                        disable the buy button, hide any verifying overlays,
     *                                                        and surface SESSION_EXPIRY_MESSAGE to the customer.
     * @param {boolean} [options.enabled]                     Master switch. When false the module no-ops:
     *                                                        startTimer/lock/handleResponse all short-circuit.
     *                                                        Defaults true.
     * @param {number}  [options.expiryDurationDays]          Session lifetime in days. Mirrors the server-side
     *                                                        CheckoutSessionConstants::EXPIRY_DURATION_DAYS.
     *                                                        Clamped to setTimeout's safe range.
     */
    function init(options) {
        _config = options || {};
        _enabled = _config.enabled !== false;
        var days = parseFloat(_config.expiryDurationDays);
        if (!isFinite(days) || days <= 0) {
            days = DEFAULT_EXPIRY_DAYS;
        }
        _expiryMs = Math.min(days * MS_PER_DAY, MAX_EXPIRY_MS);
        if (!_enabled) {
            console.log(LOG_PREFIX, 'disabled via config');
        }
    }

    /**
     * Start (or reset) the idle timer. Call on initial render and on every
     * successful re-render — customers actively interacting never hit the
     * lock; only abandoned sessions do.
     */
    function startTimer() {
        if (!_enabled || _locked) {
            return;
        }
        if (_timer !== null) {
            clearTimeout(_timer);
            console.log(LOG_PREFIX, 'timer reset');
        }
        _startedAt = Date.now();
        _timer = setTimeout(function () {
            lock('timer');
        }, _expiryMs);
        console.log(
            LOG_PREFIX, 'timer started, expires at',
            new Date(_startedAt + _expiryMs).toISOString()
        );
    }

    /**
     * Lock the session: stop the timer, mark locked, and notify the host
     * processor so it can disable its buy button and surface the message.
     * Idempotent — additional triggers after the first lock are no-ops.
     *
     * @param {string} reason 'timer' | 'backend-expired' | 'pre-submit-expired'
     *                         | 'pre-submit-error' | 'pre-submit-invalid-response'
     */
    function lock(reason) {
        if (!_enabled || _locked) {
            return;
        }
        _locked = true;
        console.log(
            LOG_PREFIX, 'locking checkout. reason=', reason,
            'started_at=', _startedAt ? new Date(_startedAt).toISOString() : null
        );
        if (_timer !== null) {
            clearTimeout(_timer);
            _timer = null;
        }
        if (typeof _config.onLock === 'function') {
            try {
                _config.onLock(reason);
            } catch (e) {
                console.error(LOG_PREFIX, 'onLock handler threw:', e);
            }
        }
    }

    /**
     * Inspect any AJAX response from a checkout-session-touching endpoint.
     * If the backend signalled expiry, lock and return false so the caller
     * can short-circuit normal response handling.
     *
     * @param {object} response
     * @returns {boolean} false when the lock fired, true otherwise.
     */
    function handleResponse(response) {
        if (!_enabled) {
            return true;
        }
        if (response && response.sessionExpired === true) {
            console.log(LOG_PREFIX, 'backend-expired response received');
            lock('backend-expired');
            return false;
        }
        return true;
    }

    function isLocked() {
        return _locked;
    }

    window.JVZoo.Checkout.Session = {
        init: init,
        startTimer: startTimer,
        lock: lock,
        handleResponse: handleResponse,
        isLocked: isLocked,
        SESSION_EXPIRY_MESSAGE: SESSION_EXPIRY_MESSAGE,
    };
})(window);
